$(document).ready(function () {
  /*$('.footer-top .footer-social .vimeo i').removeClass('fa-vimeo');
  $('.footer-top .footer-social .vimeo i').addClass('fa-whatsapp');
  $('.footer-top .footer-social .vimeo a').attr('title', 'Whatsapp');*/
  $('.tab-title').on('click', function () {
    let title = $(this);
    title.next('.tab-content').slideToggle('normal', function () {
      if (title.next('.tab-content').is(':visible')) {
        title
          .find('.fa')
          .removeClass('fa-angle-down')
          .addClass('fa-angle-up active');
      } else {
        title
          .find('.fa')
          .removeClass('fa-angle-up active')
          .addClass('fa-angle-down');
      }
    });
  });

  if ($('.wrapper-tab-content').length > 0 && $(window).width() < 768) {
    $('.wrapper-tab-content a').removeClass('active');
    $('.wrapper-tab-content .tab-content')
      .removeClass('active')
      .css('display', 'none');
  }

  if ($('.reviews-badge__button').length) {
    $('.reviews-badge__button').on('click', function (e) {
      e.preventDefault();
      document.getElementById('shopify-product-reviews').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    });
  }

  if ($('.show-more-specifications').length) {
    $('.show-more-specifications').on('click', function (e) {
      const button = $(this).find('span')[0];
      const icon = $(this).find('.fa');
      $(this)
        .siblings('#more-specifications')
        .slideToggle('normal', function () {
          let message;
          if ($(this).is(':visible')) {
            message = button.dataset.open;
            icon.removeClass('fa-angle-down').addClass('fa-angle-up active');
          } else {
            message = button.dataset.close;
            icon.removeClass('fa-angle-up active').addClass('fa-angle-down');
          }
          button.innerText = message;
        });
    });
  }

  if ($('.item-swatch [data-sku]').length) {
    changeInfoVariant();
  }

  if ($('#header-title').length) {
    const color = $('#header-title span');
    $('.swatch-element').on('click', function (e) {
      const newColor = $(this).data('value');
      color.text(newColor);
    });
  }

  if ($('.template-product').length) {
    const slidersIdentifiers = [
      { identifier: '.swatch-slider', settings: defaultSlickSettings },
      { identifier: '.recently-viewed-swacth', settings: defaultSlickSettings },
      {
        identifier: '.product__gallery',
        settings: productGallerySlickSettings,
      },
    ];
    console.log(slidersIdentifiers)
    initializeSwatchSlider(slidersIdentifiers);
    askForSPR();
  }

  if ($('#shopify-section-landings').length > 0 || $('#shopify-section-landingsnew').length > 0 || $('#shopify-section-landingcollection').length > 0 || $('#shopify-section-landingmoe').length > 0) {
    const slidersIdentifiers = [
      {
        identifier: '.new-arrivals-product .landing-slider',
        settings: newlandingSlickSettings,
      },
      {
        identifier: '.landing-collection .landing-slider',
        settings: landingSlickSettings,
      },
      { identifier: '.landing-carousel', settings: landingCarouselSettings },
      { identifier: '.landing-reviews', settings: landingReviewsSettings },
      { identifier: '.landing-sliderBanner', settings: landingSliderBannerSettings },
      {
        identifier: '.landing-collection-slider',
        settings: landingCarouselSettings,
      },
      {
        identifier: '.custom-collection-grid',
        settings: customCollectionSlickSettings,
      }
    ];
    initializeSwatchSlider(slidersIdentifiers);
  }

  if ($('.site-nav-dropdown.mobile li.menu-lv-3').length) {
    $('.site-nav-dropdown.mobile li.menu-lv-3').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const anchor = e.target.closest('a');
      window.location.href = anchor.href;
    });
  }

  if ($('.swatch-element').length) {
    $('.swatch-element').on('mouseover', function () {
      $(this).find('label.swatch_variant_img').click();
    });
  }

  if ($('.tooltip-filters').length) {
    $('.tooltip-filters').click(function (e) {
      $(this).closest('.sidebar-wrapper').addClass('open');
    });
    $('.close-sidebar').click(function (e) {
      $(this).closest('.sidebar-wrapper').removeClass('open');
    });
  }
});

const defaultSlickSettings = (itemsQuantity) => ({
  slidesToShow: 5 >= itemsQuantity ? 'unslick' : 5,
  dots: false,
  speed: 800,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  responsive: [
    {
      breakpoint: 1200,
      settings: responsiveSettings(itemsQuantity, 4),
    },
    {
      breakpoint: 769,
      settings: responsiveSettings(itemsQuantity, 4),
    },
    {
      breakpoint: 426,
      settings: responsiveSettings(itemsQuantity, 4),
    },
    {
      breakpoint: 376,
      settings: responsiveSettings(itemsQuantity, 3),
    },
  ],
});

const landingSlickSettings = (itemsQuantity) => ({
  slidesToShow: 4 >= itemsQuantity ? 'unslick' : 4,
  slidesToScroll: 1,
  dots: false,
  speed: 800,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  responsive: [
    {
      breakpoint: 2561,
      settings: responsiveSettings(itemsQuantity, 4),
    },
    {
      breakpoint: 769,
      settings: responsiveSettings(itemsQuantity, 3),
    },
    {
      breakpoint: 426,
      settings: responsiveSettings(itemsQuantity, 1),
    },
    {
      breakpoint: 376,
      settings: responsiveSettings(itemsQuantity, 1),
    },
  ],
});

const newlandingSlickSettings = (itemsQuantity) => ({
  slidesToShow: 5 >= itemsQuantity ? 'unslick' : 5,
  slidesToScroll: 1,
  dots: false,
  speed: 800,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  responsive: [
    {
      breakpoint: 2561,
      settings: responsiveSettings(itemsQuantity, 5),
    },
    {
      breakpoint: 769,
      settings: responsiveSettings(itemsQuantity, 3),
    },
    {
      breakpoint: 426,
      settings: responsiveSettings(itemsQuantity, 1),
    },
    {
      breakpoint: 376,
      settings: responsiveSettings(itemsQuantity, 1),
    },
  ],
});

const landingReviewsSettings = (itemsQuantity) => ({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  dots: false,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  adaptiveHeight: true,
});

const landingSliderBannerSettings = (itemsQuantity) => ({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  dots: false,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  adaptiveHeight: true,
});
const landingCarouselSettings = (itemsQuantity) => ({
  slidesToShow: 3 > itemsQuantity ? 'unslick' : 4,
  slidesToScroll: 1,
  dots: false,
  speed: 800,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  responsive: [
    {
      breakpoint: 769,
      settings: responsiveSettings(itemsQuantity, 2),
    },
    {
      breakpoint: 426,
      settings: responsiveSettings(itemsQuantity, 1, true, false),
    },
    {
      breakpoint: 376,
      settings: responsiveSettings(itemsQuantity, 1, true, false),
    },
  ],
});

const productGallerySlickSettings = (itemsQuantity) => ({
  slidesToShow: 'unslick',
  dots: false,
  speed: 800,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  responsive: [
    {
      breakpoint: 426,
      settings: responsiveSettings(itemsQuantity, 2),
    },
  ],
});

const customCollectionSlickSettings = (itemsQuantity) => ({
  slidesToShow: 'unslick',
  dots: false,
  speed: 800,
  nextArrow:
    "<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
  prevArrow:
    "<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
  responsive: [
    {
      breakpoint: 2561,
      settings: responsiveSettings(itemsQuantity, 4, false, true, 4),
    },
    {
      breakpoint: 769,
      settings: responsiveSettings(itemsQuantity, 3, false, true, 3),
    },
    {
      breakpoint: 426,
      settings: responsiveSettings(itemsQuantity, 1),
    },
  ],
});

const initializeSwatchSlider = (slidersIdentifiers) => {
  slidersIdentifiers.forEach((slidersIdentifier) => {
    if ($(slidersIdentifier.identifier).length) {
      const settings = slidersIdentifier.settings || productGallerySlickSettings;
      const itemsQuantity = $(slidersIdentifier.identifier).children().length;
      $(slidersIdentifier.identifier).slick(settings(itemsQuantity));
    }
  });
};

const responsiveSettings = (
  currentQuantity,
  quantity,
  dots = false,
  arrows = true,
  slidesToScroll = 1
) => {
  if (currentQuantity > quantity) {
    return {
      slidesToShow: quantity,
      slidesToScroll,
      dots,
      arrows,
    };
  }
  return 'unslick';
};

const changeInfoVariant = () => {
  $('.item-swatch [data-sku]').hover(function (e) {
    const sku = $(this)[0].dataset.sku,
      price = $(this)[0].dataset.price,
      compare = $(this)[0].dataset.compare,
      skuElement = $(this).closest('.product-item').find('.variant-sku'),
      compareElement = $(this).closest('.product-item').find('.old-price'),
      specialPriceElement = $(this)
        .closest('.product-item')
        .find('.special-price'),
      priceElement = $(this).closest('.product-item').find('.price-regular'),
      infoProductElement = $(this)
        .closest('.product-item')
        .find('.product-bottom-wrapper');

    infoProductElement.animate({ opacity: 0 }, 200, function () {
      if (compare) {
        compareElement.text(compare);
        specialPriceElement.text(price);
      } else {
        priceElement.text(price);
      }
      skuElement.text(sku);
      infoProductElement.animate({ opacity: 1 }, 200);
    });
  });
};

const askForSPR = () => {
  const askingForSPR = setInterval(() => {
    if (window['SPR']) {
      askForSPRContent();
      clearInterval(askingForSPR);
    } else {
      console.log('SPR Not ready yet');
    }
  }, 2000);

  setTimeout(() => {
    clearInterval(askingForSPR);
  }, 120000);
};

const askForSPRContent = () => {
  const askingForSPRContent = setInterval(() => {
    if ($('.spr-review-footer').length) {
      $('.spr-review-footer').on('click', function (e) {
        if (e.target.tagName != 'A') {
          const reviewAnswer = $(this).siblings('.spr-review-reply');
          reviewAnswer.slideToggle('normal');
        }
      });
      clearInterval(askingForSPRContent);
    } else {
      console.log('SPR Content Not ready yet');
    }
  }, 2000);

  setTimeout(() => {
    clearInterval(askingForSPRContent);
  }, 120000);
};
